//Jquery element animations on scroll

(function ($) {
  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  $.fn.visible = function (partial) {
    var $t = $(this),
      $w = $(window),
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom;

    return compareBottom <= viewBottom && compareTop >= viewTop;
  };

  let sponsorOptions = {};

  if ($(".sponsor-slider .swiper-slide").length > 1) {
    sponsorOptions = {
      spaceBetween: 20,
      centeredSlides: true,
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    };
  } else {
    sponsorOptions = {
      centeredSlides: true,
      loop: false,
      autoplay: false,
      spaceBetween: 20,
      slidesPerView: 1,
    };
  }

  var swiper = new Swiper(".sponsor-slider", sponsorOptions);
  var slides = $(".endorsers-slider .swiper-slide").length;

  let endorserOptions = {};
  if ($(".endorsers-slider .swiper-slide").length > 5) {
    endorserOptions = {
      spaceBetween: 20,
      centeredSlides: true,
      direction: "horizontal",
      slidesPerView: 6,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 80,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1200: {
          slidesPerView: 6,
          spaceBetween: 30,
        },
      },
    };
  } else {
    endorserOptions = {
      centeredSlides: false,
      loop: false,
      autoplay: false,
      spaceBetween: 20,
      slidesPerView: slides,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 80,
        },
        768: {
          slidesPerView: slides,
          spaceBetween: 40,
        },
      },
    };
  }

  var swiper = new Swiper(".endorsers-slider", endorserOptions);
})(jQuery);

const swiperDial = new Swiper(".swiper-dial", {
  direction: "horizontal",
  rewind: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

// const sponsorSwiper = new Swiper('.sponsor-slider', {
//   // slidesPerView: 'auto',
//   spaceBetween: 20,
//   centeredSlides: true,
//   watchOverflow: true,
//   slidesPerView: 6,
//   loop: true,
//   autoplay: {
//       delay: 2500,
//       disableOnInteraction: false,
//   },

// });

// const endorserSwiper = new Swiper('.endorsers-slider', {
//   // slidesPerView: 'auto',
//   slidesPerView: 6,
//   spaceBetween: 20,
//   watchOverflow: true,
//   centeredSlides: true,
//   loop: true,
//   autoplay: {
//       delay: 2500,
//       disableOnInteraction: false,
//   },

// });
